/**
 * OfflineIndicator - Shows a banner when the user is offline
 * Indicates that cached content is being served
 */
import { useServiceWorker } from '@/hooks/useServiceWorker';
import { WifiOff } from 'lucide-react';

const OfflineIndicator = () => {
  const { isOffline } = useServiceWorker();

  if (!isOffline) return null;

  return (
    <div 
      className="fixed bottom-4 left-4 z-50 flex items-center gap-2 px-4 py-2 bg-amber-100 border border-amber-300 rounded-lg shadow-lg animate-in fade-in slide-in-from-bottom-2"
      role="alert"
      data-testid="offline-indicator"
    >
      <WifiOff className="w-4 h-4 text-amber-600" />
      <span className="text-sm text-amber-800 font-medium">
        You're offline. Showing cached content.
      </span>
    </div>
  );
};

export default OfflineIndicator;
